











































































































































































import { Component, Prop, Emit } from 'vue-property-decorator'
import { mixins } from 'vue-class-component'
import Form from '@/mixins/form'
import { createNewPdPayload } from '@/api/pd/utils'
import { Tabs, TabSettingName } from '@/constants/appSettings'

@Component({
  components: {
    DatetimeSelectInputGroup: () =>
      import('./PdCreateRegisteredDatetimeInputGroup.vue'),
    NumberInput: () => import('@/components/common/inputs/NumberInput.vue'),
    RadioInput: () => import('@/components/common/inputs/RadioInput2.vue'),
    CheckboxInput: () => import('@/components/common/inputs/CheckboxInput.vue'),
    FileInput: () => import('@/components/common/inputs/FileInput.vue'),
    Loading: () => import('@/components/common/loadings/UploadLoading.vue')
  }
})
export default class PdCreate extends mixins(Form) {
  @Prop(Number) patientId!: number
  inputs = createNewPdPayload()
  errorMessage = ''
  pending = false
  selectexitsiteImage = false
  selectWasteFluidImage = false
  cancelButtonLink = Tabs[TabSettingName.pd].routeName

  @Emit('submit')
  onSubmit() {
    return
  }

  get wasteFluidOptions() {
    return [
      { label: '正常', value: '1' },
      { label: 'フィブリン', value: '2' },
      { label: '混濁', value: '3' }
    ]
  }
  get wasteFluids() {
    const value = this.inputs.wasteFluid
    return value ? value.split(',') : []
  }

  get exitsiteOptions() {
    return [
      { label: '正常', value: '1' },
      { label: '赤み', value: '2' },
      { label: '痛み', value: '3' },
      { label: '腫れ', value: '4' },
      { label: 'かさぶた', value: '5' },
      { label: '膿', value: '6' }
    ]
  }
  get exitsites() {
    const value = this.inputs.exitsite
    return value ? value.split(',') : []
  }

  get swellingOptions() {
    return [
      { label: '無', value: '0' },
      { label: '有', value: '1' },
      { label: '悪化', value: '2' }
    ]
  }
  get swellings() {
    const value = this.inputs.swelling
    return value ? value.split(',') : []
  }

  setWasteFluid(value: string, checked: boolean) {
    const values = this.wasteFluids
    const newValues = checked
      ? [...values, value]
      : values.filter(v => v != value)
    this.inputs.wasteFluid = newValues.join(',')
  }

  setExitsite(value: string, checked: boolean) {
    const values = this.exitsites
    const newValues = checked
      ? [...values, value]
      : values.filter(v => v != value)
    this.inputs.exitsite = newValues.join(',')
  }

  setSwelling(value: string, checked: boolean) {
    const values = this.swellings
    const newValues = checked
      ? [...values, value]
      : values.filter(v => v != value)
    this.inputs.swelling = newValues.join(',')
  }

  isWorkerSide() {
    return this.$route.name === 'PdTabCreate'
  }

  handleChangeDrainVolume(value: number | null) {
    this.inputs.waterRemoval =
      Number(value) - Number(this.inputs.infusionVolume)
  }

  handleChangeInfusionVolume(value: number | null) {
    this.inputs.waterRemoval = Number(this.inputs.drainVolume) - Number(value)
  }

  async handleSubmit() {
    this.errorMessage = ''

    if (this.pending) {
      return
    }

    if (this.validator.hasAnyError()) {
      this.errorMessage = this.validator.getFirstErrorMessage()
      return
    }

    this.pending = true

    try {
      const payload = { ...this.inputs }

      payload.hasWasteFluidImage = payload.wasteFluidImage != null
      payload.hasExitsiteImage = payload.exitsiteImage != null

      if (!payload.hasExitsiteImage) {
        delete payload.exitsiteImage
        delete payload.exitsiteImageFileName
      }
      if (!payload.hasWasteFluidImage) {
        delete payload.wasteFluidImage
        delete payload.wasteFluidImageFileName
      }

      await this.$api.pd.create({
        patientId: this.patientId,
        payload
      })

      this.inputs = createNewPdPayload()

      if (this.isWorkerSide()) {
        this.$router.push({ name: 'PdTab' })
      }

      this.onSubmit()
    } catch (error) {
      console.error(error)
      this.errorMessage = '保存できませんでした。'
    } finally {
      this.pending = false
    }
  }
}
